export default {
      id: "login-usage",
      viewBox: "0 0 18 20",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#login",
      toString: function () {
        return this.url;
      }
    }